// Import local scripts
// @ts-ignore
import './aria.modal.js'
import EmblaCarousel from 'embla-carousel'

// Handle Mobile menu
const mobileMenu = document.querySelectorAll(".nav-mobile-menu .mobile-menu li.expandable > a > span")
function mobileExpand(event: Event) {
    const parent = (event.target as HTMLElement).closest('.expandable')

    if (parent) {
        parent.classList.toggle("expanded")
    }

    event.preventDefault()
    return false
}

if (mobileMenu) {
    mobileMenu.forEach((item) => {
        item.addEventListener('click', mobileExpand, false)
        item.addEventListener('touchend', mobileExpand, false)
    });
}

const mainNav = document.querySelectorAll('.nav-main-menu ul > li.expandable > a') as NodeListOf<HTMLLinkElement>

mainNav.forEach((link: HTMLLinkElement)=> {
    const dropdown = link.parentNode?.querySelector('.dropdown-menu') as HTMLElement

    if (dropdown) {
        link.addEventListener('focus', function() {
            dropdown.style.display = 'flex'
        })

        link.addEventListener('blur', function(e) {
            setTimeout(() => {
                if (!link.parentNode?.contains(document.activeElement)) {
                    dropdown.style.display = ''
                }
            }, 150)
        })

        const dropdownLinks = dropdown.querySelectorAll('a')
        dropdownLinks.forEach(function(dropdownLink, index) {
            dropdownLink.addEventListener('blur', function(e) {
                setTimeout(() => {
                    if (!link.parentNode?.contains(document.activeElement)) {
                        dropdown.style.display = ''
                    }
                }, 150)
            })
        })
    }
})

// Masonry grid transition
const masonry = document.querySelectorAll('.masonry-grid');
masonry.forEach( (element) => {

    let animating = false;

    element.querySelectorAll('.masonry-grid-item').forEach( (item) => {

        item.addEventListener('mouseenter', () => {

            const isLgScreen = window.matchMedia('(min-width: 64rem)').matches
            if (!isLgScreen) return

            // Do nothing if a transition is already running
            if (animating) return

            // Do nothing if this item is already active
            if (item.classList.contains('active')) return

            const updateState = () => {
                const current = element.querySelector('.masonry-grid-item.active') as HTMLElement
                if (current) {
                    current.classList.remove('active');
                }
                item.classList.add('active');
            };

            // Use the startViewTransition method if it exists, otherwise just update the state immediately
            if (document.startViewTransition) {
                animating = true;
                document.startViewTransition(updateState).finished.finally(() => {
                    setTimeout(() => {
                        animating = false;
                    }, 300);
                });
            } else {
                updateState();
            }
        })
    })

})

/**
 * Icon features
 */
const iconFeatures = document.querySelectorAll('.icon-features')
iconFeatures.forEach((featuresContainer) => {
    /**
     * Set up each feature in the group
     */
    featuresContainer.querySelectorAll<HTMLElement>('.icon-feature').forEach((feature) => {
        const button = feature.querySelector<HTMLButtonElement>('button[aria-expanded]')
        const panel = feature.querySelector<HTMLElement>('.icon-feature__panel')

        if (!button || !panel) return

        const openPanel = () => {
            panel.classList.add('open')
            button.setAttribute('aria-expanded', 'true')
            const firstFocusable = panel.querySelector<HTMLElement>('a[href], button:not([disabled])')
            firstFocusable?.focus()
        }

        const closePanel = () => {
            panel.classList.remove('open')
            button.setAttribute('aria-expanded', 'false')
        }

        button.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
                console.log('Enter or Space pressed')
                e.preventDefault()
                panel.classList.contains('open') ? closePanel() : openPanel()
            }
        })

        // Close when focus leaves the feature entirely
        feature.addEventListener('focusout', (e: FocusEvent) => {
            if (!feature.contains(e.relatedTarget as Node)) {
                closePanel()
            }
        })
    })
})

/** Carousel setup */
const setupCarousels = () => {
    const carouselWrapper = document.querySelectorAll('.embla')
    carouselWrapper.forEach( (element) => {

        // If already initialized, do nothing
        if (element.classList.contains('embla__initialized')) return

        const viewport = element.querySelector('.embla__viewport') as HTMLElement

        const api = EmblaCarousel(viewport, {})

        // Add a class to the carousel wrapper when it's initialized'
        api.on('init', (api) => {
            element.classList.add('embla__initialized')
        })

        const thumbnails = element.querySelectorAll('.embla__thumbnail') as NodeListOf<HTMLElement>;
        thumbnails.forEach( (thumbnail) => {
            const index = thumbnail.dataset.index
            if (index === undefined) return

            thumbnail.addEventListener('click', () => {
                api.scrollTo(Number(index))
            })
        })
    })
}

/** Carousel init if the screen is wide enough */
if (window.matchMedia('(min-width: 48rem)').matches) {
    setupCarousels()
}

/** Carousel enable on resize if the screen is wide enough */
window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 48rem)').matches) {
        setupCarousels()
    }
})